import React, { Component, Fragment } from 'react'

import Template from './TemplateLandingPage'
import TwoColsB2B from '../../../blocks/LandingPageBlocks/TwoColsB2B'
import WhyUse from '../../../blocks/LandingPageBlocks/WhyUse'
import CardsEstrategiasB2B from '../../../blocks/CardsEstrategias/CardsEstrategiasB2B'
import NewMenu from '../../../blocks/Menu/NewMenu'
import CenteredTitleSection from '../../../blocks/LandingPageBlocks/CenteredTitleSection'
import Hero from '../../../blocks/LandingPageBlocks/Hero'

export default class DistributorApp2v2 extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Fragment>
                <NewMenu
                    pixelsToShowMenuWhite={50}
                    mutableMenu
                />
                <Template b2b>
                    <Hero b2b title={<Fragment>Seus clientes fazendo pedidos no seu <strong>catálogo online</strong> a qualquer hora e lugar</Fragment>} description='Conquiste novos mercados, atenda clientes distantes e pare de receber pedidos pelo WhatsApp e e-mail.' />
                    <WhyUse b2b variation="V3" title={<Fragment>O que é o <br /><strong>catálogo online?</strong></Fragment>} image='distribuidoras'>
                        <h3>O catálogo online é uma loja virtual para empresas que vendem para outras empresas (business-to-business). Indústrias, distribuidores e representantes podem oferecer um e-commerce completo para seus clientes lojistas com todos os produtos, orçamentos, lançamentos e promoções.</h3>
                    </WhyUse>
                    <CenteredTitleSection title={<Fragment>O catálogo online te ajuda a <br />potencializar e gerenciar suas vendas</Fragment>} />
                    <TwoColsB2B />
                    <CardsEstrategiasB2B CTA title='Catálogo online Mercos: o mais inteligente do mercado' />
                </Template>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/OnlineCatalogv2.jsx